import { State } from 'redux/initialState';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { BoardEntityTypes } from 'types/Board';
import { boardsViewTypes } from '../constants/boardsViewTypes';
import { boardsSubtitles } from '../constants/boardsSubtitles';
import { boardsDescriptions } from '../constants/boardsDescriptions';
import { boardsAddButtonTexts } from '../constants/boardsAddButtonTexts';

type UseGetBoardsListHeaderProps = {
  boardType: BoardEntityTypes;
  viewType: string;
  boardsCount: number;
};

export const useGetBoardsListHeader = ({
  boardType,
  viewType,
  boardsCount,
}: UseGetBoardsListHeaderProps) => {
  const actualSociety = useSelector(
    (state: State) => state.society?.actualSociety
  );

  const [subtitleText, setSubtitleText] = useState<string>('');
  const [descriptionText, setDescriptionText] = useState<string>('');
  const [addBoardsButtonText, setAddBoardsButtonText] = useState<string>('');
  const [addBoardsButtonIcon, setAddBoardsButtonIcon] = useState<string>('');

  useEffect(() => {
    const subtitle = boardsSubtitles[boardType as keyof typeof boardsSubtitles];
    setSubtitleText(subtitle);

    const descriptionText =
      boardsDescriptions[boardType as keyof typeof boardsDescriptions];
    setDescriptionText(descriptionText);

    const addBoardsButtonText =
      boardsAddButtonTexts[boardType as keyof typeof boardsAddButtonTexts];
    setAddBoardsButtonText(addBoardsButtonText);

    const addBoardsbuttonIcon =
      viewType === boardsViewTypes.LIST ? 'dashboard' : 'list';
    setAddBoardsButtonIcon(addBoardsbuttonIcon);
  }, [boardType, viewType, boardsCount]);

  return {
    data: {
      subtitleText,
      descriptionText,
      addBoardsButtonText,
      addBoardsButtonIcon,
    },
  };
};
